<template>
    <div id="pc_index">
        <mobileHeader v-if="isMobile == 'Mobile'"></mobileHeader>
        <Header v-else></Header>
        <!-- <div class="backimg"><img src="../assets/headerimg.png" fit="cover"></div> -->
        <swiper
            v-if="swiperList.length > 0"
            class="swiper-container"
            :class="{ 'swiper-mobile': isMobile == 'Mobile' }"
            :modules="modules"
            :pagination="{ clickable: true }"
            :autoplay="{
                delay: 4000,
                disableOnInteraction: false,
            }"
            :loop="true"
        >
            <swiper-slide v-for="(item, index) in swiperList" :key="index">
                <a :href="item.link_url"><img class="sitem" :src="item.image_url"/></a>
            </swiper-slide>
        </swiper>
        <!-- <div class="bigimg"><img src="../assets/headerimg.png"></div> -->
        <!-- <div class="timadd flex">
            <div class="one">
                <img src="../assets/backimg.png" alt="">
                <div class="dark">
                    <h2>开放时间</h2>
                    <div class="tim flex">
                        <img src="../assets/search.png">
                        <h2>10:00~18:00</h2>
                    </div>
                    <p>17:30后停止入场，除法定节假日外，周一闭馆</p>
                    <div class="btn flex"><p>查看更多</p><img src="../assets/zhuan.png"></div>
                </div>
            </div>
            <div class="one">
                <img src="../assets/backimg.png" alt="">
                <div class="dark">
                    <h1>民生现代美术馆</h1>
                    <h1>电子导览</h1>
                    <div class="btn flex"><p>马上查看</p><img src="../assets/zhuan.png"></div>
                </div>
            </div>
        </div>
        <div class="hot">
            <p class="tit">热门展览/活动</p>
            <div class="huodong">
                <div class="leftimg flex">
                    <img src="../assets/right.png" alt="" class="zhutu">
                    <div class="blackbox">
                        <div class="tips">展览</div>
                        <h1>文明的起源——早期中华文明探寻大展</h1>
                        <p>2024.1.13-2024.7.13</p>
                        <p>一展厅/一层大厅</p>
                        <div class="btn flex"><p>详情页面</p><img src="../assets/zhuan.png"></div>
                    </div>
                </div>
                <div class="leftimg flex">
                    <div class="blackbox">
                        <div class="tips">展览</div>
                        <h1>文明的起源——早期中华文明探寻大展</h1>
                        <p>2024.1.13-2024.7.13</p>
                        <p>一展厅/一层大厅</p>
                        <div class="btn flex"><p>详情页面</p><img src="../assets/zhuan.png"></div>
                    </div>
                    <img src="../assets/right.png" alt="" class="zhutu">
                </div>
            </div>
            <div class="tolist flex">
                <div class="btn flex"><p>查看全部当前活动</p><img src="../assets/zhuan.png"></div>
                <div class="btn flex"><p>查看全部正在展出</p><img src="../assets/zhuan.png"></div>
            </div>
        </div>
        <div class="toggle">
            <div class="heiqie">
                <div class="qie flex">
                    <div class="btn flex" :class="{ 'act': activeTab == 0 }" @click="activateTab(0)"><p>过往展览</p><img src="../assets/zhuan.png"></div>
                    <div class="btn flex" :class="{ 'act': activeTab == 1 }" @click="activateTab(1)"><p>往期活动</p><img src="../assets/zhuan.png"></div>
                </div>
            </div>
            <div class="qielist flex">
                <div class="listbox" v-for="(item, index) in arrList" :key="index">
                    <img src="../assets/list1.png">
                    <h3>文明的起源——早期中华文明探寻大展</h3>
                    <p>2024.1.13-2024.7.13</p>
                </div>
            </div>
            <div class="tolist flex">
                <div class="btn flex"><p>查看全部过往展出</p><img src="../assets/zhuan.png"></div>
            </div>
        </div>
        <div class="friends">
            <p class="tit">友情链接</p>
            <div class="qielist flex">
                <div class="listbox" v-for="(item, index) in friendsList" :key="index">
                    <img :src="item.logo">
                    <div class="fname flex"><p>{{item.name}}</p></div>
                </div>
            </div>
            <div class="tolist flex">
                <div class="btn flex"><p>艺术品商店</p><img src="../assets/zhuan.png"></div>
                <div class="btn flex"><p>志愿者报名</p><img src="../assets/zhuan.png"></div>
            </div>
        </div> -->
    </div>
</template>

<script setup>
    import { getbannerList } from "../utils/gerData";
    import { ref, onMounted, onBeforeUnmount } from 'vue';
    import {Swiper, SwiperSlide} from 'swiper/vue';
    import {Pagination, A11y, Autoplay} from 'swiper/modules';
    import 'swiper/css';
    import 'swiper/css/pagination';
    import 'swiper/css/autoplay';
    import { imageurl } from "../utils/i18nLabels";

    const modules = [Pagination, A11y, Autoplay]
    const activeTab = ref(0);
    const arrList = ref([1,1,1,1,1,1,1,1,1,1]);
    const swiperList = ref([])
    const friendsList = ref([])
    const isMobile = localStorage.getItem('userAgent')
    

    // 切换
    function activateTab(num) {
        activeTab.value = num;
    };

    // 获取轮播和友情链接数据
    function getList() {
        let queryParams = {
            page: 1,
            pageSize: 100
        }
        getbannerList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image_url = item.image_url ? imageurl + item.image_url : undefined
            })
            swiperList.value = data.list;
        });
    }
    getList()
</script>

<style scoped>
    #pc_index{
        overflow: hidden;
    }
    .backimg{
        position: relative;
        img{
            position: fixed;
            width: 100%;
            height: 100vh;
            z-index: -1;
            top: 0;
            left: 0;
        }
    }
    .swiper-container {
        /* margin-top: 100px; */
        background-color: white;
    }
    
    /* 移动端轮播图适配 */
    .swiper-mobile {
        margin-top: 80px; /* 移动端header高度适配 */
    }
    
    ::v-deep .swiper-pagination-bullets{
        bottom: 60px;
    }
    
    /* 移动端分页器适配 */
    .swiper-mobile ::v-deep .swiper-pagination-bullets{
        bottom: 20px;
    }
    
    ::v-deep .swiper-pagination-bullet {
        background-color: white; /* 修改分页器小圆点的颜色 */
        width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 12px));
        height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 12px));
    }
    
    /* 移动端分页器小圆点适配 */
    .swiper-mobile ::v-deep .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        margin: 0 3px;
    }
    
    ::v-deep .swiper-pagination-bullet-active {
        background-color: white; /* 修改当前激活的分页器小圆点的颜色 */
    }
    
    ::v-deep .swiper-slide{
        width: 100%;
        height: 780px;
    }
    
    /* 移动端轮播图高度适配 */
    .swiper-mobile ::v-deep .swiper-slide{
        height: 250px; /* 移动端适合的高度 */
    }
    
    .sitem {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .bigimg{
        margin-top: 100px;
        width: 100%;
        img{
            width: 100%;
            height: auto;
            display: block;
        }
    }
    .timadd{
        box-sizing: border-box;
        width: 100%;
        padding: 92px 110px;
        background: white;
        margin-bottom: 116px;
        .one{
            position: relative;
            color: white;
            text-align: center;
            img{
                width: 600px;
                height: 360px;
            }
            .dark{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: rgba(0, 0, 0, .8);
                box-sizing: border-box;
                padding: 60px 0;
                h1{
                    margin-bottom: 15px;
                }
                
                .btn{
                    cursor: pointer;
                    position: absolute;
                    bottom: 40px;
                    left: 50%;
                    margin-left: -130px;
                    color: black;
                    font-size: 24px;
                    background: white;
                    width: 260px;
                    height: 60px;
                    box-sizing: border-box;
                    padding: 0 20px 0 30px;
                    font-weight: bold;
                    img{
                        width: 6px;
                        height: 12px;
                    }
                }
                .btn:hover{
                    background: black;
                    color: white;
                    border: 1px solid white;
                }
                .tim{
                    justify-content: center;
                    margin: 20px 0;
                }
                img{
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }
            }
        }
    }
    
    .hot{
        background: white;
        margin-bottom: 116px;
        .huodong{
            box-sizing: border-box;
            width: 100%;
            padding: 0 110px;
            background: white;
            .zhutu{
                width: 50%;
                height: 100%;
            }
            .leftimg{
                text-align: left;
                height: 586px;
                .blackbox{
                    width: 50%;
                    height: 100%;
                    color: white;
                    box-sizing: border-box;
                    padding: 45px;
                    background: #232323;
                    .tips{
                        width: 100px;
                        height: 40px;
                        font-size: 24px;
                        color: #232323;
                        background: white;
                        text-align: center;
                        font-weight: bold;
                        margin: 30px 0;
                    }
                    h1{
                        font-size: 50px;
                        margin-bottom: 40px;
                    }
                    p{
                        font-size: 25px;
                    }
                    .btn{
                        cursor: pointer;
                        color: black;
                        font-size: 24px;
                        background: white;
                        width: 260px;
                        height: 60px;
                        box-sizing: border-box;
                        padding: 0 20px 0 30px;
                        font-weight: bold;
                        margin-top: 40px;
                        img{
                            width: 6px;
                            height: 12px;
                        }
                    }
                    .btn:hover{
                        background: black;
                        color: white;
                        border: 1px solid white;
                    }
                }
                
            }
        }
    }
    
    .tolist{
        padding: 116px 0;
        justify-content: center;
        .btn{
            cursor: pointer;
            color: white;
            font-size: 24px;
            background: black;
            width: 300px;
            height: 60px;
            box-sizing: border-box;
            padding: 0 20px 0 30px;
            font-weight: bold;
            margin: 0 50px;
            img{
                width: 6px;
                height: 12px;
            }
        }
        .btn:hover{
            background: white;
            color: black;
            border: 1px solid black;
        }
    }
    .tit{
        font-size: 40px;
        color: #232323;
        font-weight: bold;
        text-align: center;
        line-height: 160px;
    }
    .toggle{
        box-sizing: border-box;
        width: 100%;
        padding: 90px 110px 0;
        background: white;
        margin-bottom: 116px;
        .heiqie{
            width: 100%;
            height: 150px;
            background: #232323;
            .qie{
                justify-content: center;
                font-weight: bold;
                font-size: 36px;
                text-align: center;
                color: white;
                .btn{
                    cursor: pointer;
                    flex-direction: column;
                    justify-content: space-around;
                    width: 49%;
                    height: 130px;
                    margin-top: 20px;
                }
                .act{
                    background: white;
                    color: black;
                }
                img{
                    transform: rotate(90deg);
                }
            }
        }
    }
    
    .qielist{
        flex-wrap: wrap;
        justify-content: flex-start;

        .listbox{
            width: 300px;
            text-align: left;
            margin: 100px 12px 0;
        }
        .listbox img{
            width: 300px;
            height: 300px;
        }
        .listbox h3{
            font-size: 18px;
            line-height: 60px;
        }
        .listbox p{
            color: #6b6b6b;
        }
    }

    .friends{
        text-align: center;
        background: white;
        padding: 0 110px 116px;
        .qielist{
            justify-content: space-between;
        }
        .listbox{
            width: 180px;
            margin: 0;
        }
        .fname{
            width: 100%;
            height: 80px;
            border-bottom: 1px solid black;
            justify-content: center;
        }
        img{
            width: 100%;
        }
    }
</style>